<script>
    export let switchHandler
	export let copySource

    export const brandBarMarriottTopLogo = './images/bonvoy_logo.png';
    export const brandBarLogoEdition = './images/edition_logo.png';
    export const brandBarLogoRitz = './images/ritz_carlton_logo.png';
    export const brandBarLogoLuxCol  = './images/luxury_collection_logo.png';
    export const brandBarLogoStrergis  = './images/st_regis_logo.png';
    export const brandBarLogoWHotels  = './images/w_hotels_logo.png';
    export const brandBarLogoJW = './images/jw_marriott_logo.png';
    export const brandBarLogoSheraton = './images/logo_Sheraton.svg';
    export const brandBarLogoVacaClub = './images/logo_Marriott_Vacation_Clubs.svg';
    export const brandBarLogoMGM = './images/logo_MGM_Collection.svg';
    export const brandBarLogoDelta = './images/delta_hotels_logo.png';
    export const brandBarLogoWestin = './images/westin_logo.png';
    export const brandBarLogoMerid = './images/meridien_logo.png';
    export const brandBarLogoRen = './images/renaissance_hotels_logo.png';
    export const brandBarLogoAuto = './images/auto_collect_hotels_logo.png';
    export const brandBarLogoTrib = './images/tribute_portfolio_logo.png';
    export const brandBarLogoDesign = './images/design_hotels_logo.svg';
    export const brandBarLogoGL = './images/gaylord_hotels_logo.png';
    export const brandBarLogoCourt = './images/courtyard_logo.png';
    export const brandBarLogoFP = './images/four_points_logo.png';
    export const brandBarLogoSpring = './images/springhill_suites_logo.png';
    export const brandBarLogoFair = './images/fairfield_logo.png';
    export const brandBarLogoProt = './images/protea_hotels_logo.png';
    export const brandBarLogoAC = './images/ac_hotels_logo.png';
    export const brandBarLogoLoft = './images/aloft_logo.png';
    export const brandBarLogoMoxy = './images/moxy_hotels_logo.png';
    export const brandBarLogoCityExpress = './images/city-express-logo.svg';
    export const brandBarLogoFourPointsExpress = './images/four-pointd-flex-logo.svg';
    export const brandBarLogoHomes = './images/hv_logo.png';
    export const brandBarLogoRes = './images/residence_inn_logo.png';
    export const brandBarLogoTown = './images/towneplace_suites_logo.png';
    export const brandBarLogoMarriott = './images/marriott_exec_apartments_logo.png';
    export const brandBarLogoEle = './images/element_logo.png';
    export const brandBarLogoMarriottRes = './images/marriott_logo.png';
    export const brandBarLogoApartments = './images/logo-apartments.svg';
    export const brandBarLogoStudiorRes = './images/studio-res-logo.svg';
    export const brandBarLogoOutdoorCollection = './images/logo_OutdoorCollection.svg';
    export const brandBarLogoCitizenM = './images/logo_CitizenM.png';
    export const brandBarLogoSeriesByMarriott = './images/logo_SeriesByMarriott.png';

    setTimeout(()=>{
        let isScriptLinkVisible  = document.getElementById("teconsent") === null ? false : true;
        if (isScriptLinkVisible) {
            document.getElementById("footer-tracking-link").innerHTML = "";
            document.getElementById("footer-tracking-link").append(document.getElementById("teconsent"));
        }

    }, 2000);
    
</script>

<style>
    footer {
        background: #1C1C1C;
        color: #fff;
        margin-bottom: 10px;
    }    

    footer ul {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding:0;
    }

    :global(a,
    #ccpacontainer>a) {
        text-decoration: none;
        color:#1c1c1c;
    }

    :global(a:hover,
    #ccpacontainer>a:hover) {
        text-decoration: underline;
    }

    li {
        font-size: 12px;
        line-height: 14px;
        color: #fff;
        margin-right: 7px;
        padding: 5px 0;
        white-space: nowrap;
        font-family: "Swiss721BT-BoldCondensed";
    }

    li:first-of-type {
        padding-left: 0;
    }
    li:last-of-type {
        border-right: none;
    }

    p {
        font-size: 11px;
        line-height: 14px;
        color: #fff;
        margin-top: 0;
        margin-bottom: 0;
    }

    .points-con {
        background-color: #F9F6F4;
        width: auto;
        padding: 30px;
    }

    .points-con > img {
        display: block;
        max-width: 220px;
        margin: auto;
    }

    .footer-contents {
        width: 90%;
        max-width: 1180px;
        margin: auto;
        margin-top: 25px;
        padding: 12px;
        padding-bottom: 25px;
        font-family: 'Swiss721 Regular';
        border-top: 1px solid #F9F6F4;
    }

    select {
        display: inline-block;
        margin: 0;
        text-align: left;
        font-size: 12px;
        -webkit-appearance:none;
        -moz-appearance:none;
        -ms-appearance:none;
        background-color: #1C1C1C;
        color: #fff;
        border: none;
    }

    select::-ms-expand {
        /* IE11 JOY */
        display: none;
    }

    option {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
    }

    .footer-line-one {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 30px;
        margin-bottom: 10px;
    }
    .footer-line-one>p { 
        max-width: 70%;
        word-wrap: break-word;
    }
    .footer-line-one>p>a { 
        color: #FFFFFF;
        text-decoration: underline;
    }

    .footer-line-one > div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        align-self: flex-start;
    }

    .lang-icon {
        transform: scale(0.8);
    }

    .footer-line-two > ul {
        display: flex;
        justify-content: flex-start;
    }
    .footer-contents .footer-line-two > ul > li > a {
        color: #fff;
        text-align: left;
        border-right: 1px solid #6c6c6c;
    }

    .footer-contents .footer-line-two > ul > li > a:after {
        display: inline-block;
        content:'\276F';
        font-size: 14px;
        color: #fff;
        margin: 0 7px;
    }

    /* Rebrand */
.brand-bar-section {
    background-color: #fff;
    padding: 40px;
    padding-top: 60px;
}
.footer-brand-bar {
    /* border: 1px solid #6c6c6c;
    border-radius: 20px; */
     /* border-top: 2px solid #6c6c6c; */
     border: 0.125rem solid rgb(238, 238, 238);
     position: relative;
     text-align: center;
     margin-top: 40px;
     background-color: #fff;
     /* width: 100%; */
     max-width: 1270px;
     margin: auto;
     padding: 50px 20px 4px;
}
.footer-brand-container { 
    width: 98%;
    /* margin: 12px auto 0; */
}
.footer-brand-container > div {
    margin: 0;
}

.footer-brand-container > div:last-of-type {
    margin-bottom: 10px;
}


 .footer-brand-bar ul, .footer-brand-bar li {
     padding: 0;
     margin: 0;
}
 .footer-brand-bar li {
     list-style: none;
     color: #6f6f6f;
     font-weight: 600;
     font-family: 'Swiss721BT-BoldCondensed', Helvetica, Arial, sans-serif;
     font-size: 14px;
}
 .footer-brand-bar li a {
     display: block;
}
 .footer-brand-bar li img {
     width: 100%;
     display: block;
}
.footer-logo-list-con {
    margin: 4px 0;
}
.footer-logo-list {
    justify-content: center;
    gap: 2px 20px;
    flex-wrap: nowrap;
    align-items: center;
}
 .footer-brand-bar .footer-mainlogo, .footer-brand-bar .footer-logo-list-con {
     display: inline-block;
     vertical-align: middle;
}
 .footer-brand-bar .footer-mainlogo {
     position: absolute;
     top: -40px;
     right: 50%;
     transform: translateX(50%);
     max-width: 200px;
}
 .footer-brand-bar .footer-mainlogo img {
     background: #fff;
     /* width: 100%; */
}
 /* .footer-brand-bar .footer-mainlogo li {
     width: 100%;
} */
 .footer-brand-bar .footer-mainlogo li:last-of-type {
     margin-bottom: 0;
}
 .footer-brand-bar .footer-logo-list-con {
     width: 100%;
     display: inline-block;
}
 
 
 .footer-brand-bar .footer-logo-list-con li {
     width: 70px;
     display: inline-block;
     margin-right: -0;
     vertical-align: middle;
}
 .footer-brand-bar .footer-logo-list-con li:hover {
     color: #707070;
}

 .footer-brand-grp2 br {
     display: none;
}
 
.footer-category-con {
     display: block;
}

@media screen and (max-width: 768px) {
    .brand-bar-section {
        padding: 35px 5px;
}
    .footer-brand-bar {
         margin:  auto;
         margin-top: 20px;
         height: 100%;
         padding: 0;
    }

    .footer-logo-list {
        flex-wrap: wrap;
    }
    .footer-brand-bar .footer-logo-list-con {
         width: 100%;
         margin-right: 0px;
    }
    .footer-brand-bar .footer-logo-list-con li {
         width: 18%;
         margin-bottom: 30px;
    }
    .footer-brand-grp2 br {
         display: block;
    }
     .footer-category-con {
         width: 100%;
         text-align: center;
         margin: 12px 0;
    }
}
 @media screen and (max-width: 560px) {
    .footer-brand-bar .footer-logo-list-con li {
         width: 20%;
         margin-bottom: 30px;
    }
    .footer-brand-bar .footer-logo-list-con {
         width: 100%;
         margin-right: 0px;
    }
    .footer-brand-bar .footer-logo-list-con .footer-logo-list:first-of-type {
         margin-left: 0;
    }
    .footer-brand-grp2 br {
         display: none;
    }
    .footer-brand-bar .footer-mainlogo li {
         display: inline-block;
         margin-right: -4px;
         vertical-align: middle;
         width: 33.3%;
    }
     .footer-category-con {
         width: 100%;
         text-align: center;
         margin-left: 0;
         margin-right: 0;
         margin-bottom: 12px;
    }
}
 .footer-category-con span {
     list-style: none;
     color: #6f6f6f;
     font-family: 'Swiss721BT-BoldCondensed', Helvetica, Arial, sans-serif;
     font-size: 12px;
}
 .footer-category-con:last {
     padding-bottom: 0px;
}
 

    @media screen and (max-width: 400px) {
        .footer-line-two > ul {
            flex-direction: column;
        }
    }


    @media screen and (max-width: 480px) {
        footer > div {
            width: auto;
        }
    }
    @media screen and (max-width: 768px) {
        .footer-brand-container{
            margin-top: 60px;
        }
    }
    .footer-mainlogo img{
        padding-right: 18px;
        padding-left: 22px;
        margin-top: 16px;
    }

</style>

<footer>
    <div class="points-con">
        <img src='./images/Points-PGC-LOGO-EN.png' alt="Powered by Points." />
    </div>

    <!-- rebrand -->
    <div class="brand-bar-section">
        <div class="footer-brand-bar">
           <div class="footer-mainlogo">
               <a target="_blank" href="http://www.ritzcarlton.com/en/rewards">
                   <img src="{brandBarMarriottTopLogo}" alt="Marriott Bonvoy">
               </a>
               
           </div>
           <div class="footer-brand-container">
             <div class="footer-brand-grp1">
                <div class="footer-category-con">
                   <span title="{copySource.footer.footerbar.grp1}">{copySource.footer.footerbar.grp1}</span>
                </div>
                <div class="footer-logo-list-con">
                    <ul class="footer-logo-list" id="footer-logo-list-luxury">
                        <li><a target="_blank" href="http://www.editionhotels.com/"><img src="{brandBarLogoEdition}" alt="Edition Hotels"></a></li>
                        <li><a target="_blank" href="http://www.ritzcarlton.com/"><img src="{brandBarLogoRitz}" alt="Ritz Carlton"></a></li>
                        <li><a target="_blank" href="https://the-luxury-collection.marriott.com/"><img src="{brandBarLogoLuxCol}" alt="the luxury collection"></a></li>
                        <li><a target="_blank" href="https://st-regis.marriott.com/"><img src="{brandBarLogoStrergis}" alt="st regis"></a></li>
                        <li><a target="_blank" href="https://w-hotels.marriott.com/"><img src="{brandBarLogoWHotels}" alt="w hotels"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/jw-marriott/travel.mi"><img src="{brandBarLogoJW}" alt="JW Marriot"></a></li>
                     </ul>  
                </div>
              </div>
              <div class="footer-brand-grp2">
                  <div class="footer-category-con">
                      <span title="{copySource.footer.footerbar.grp2}">{copySource.footer.footerbar.grp2}</span>
                  </div>
                  <div class="footer-logo-list-con">
                    <ul class="footer-logo-list" id="footer-logo-list-premium">
                        <li><a target="_blank" href="http://www.marriott.com/marriott-hotels-resorts/travel.mi"><img src="{brandBarLogoMarriottRes}" alt="Marriot Hotels Resorts"></a></li>
                        <li><a target="_blank" href="https://sheraton.marriott.com/"><img src="{brandBarLogoSheraton}" alt="sheraton"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/delta-hotels/travel.mi"><img src="{brandBarLogoDelta}" alt="Delta Hotels"></a></li>
                        <li><a target="_blank" href="https://westin.marriott.com/"><img src="{brandBarLogoWestin}" alt="westin"></a></li>
                        <li><a target="_blank" href="https://le-meridien.marriott.com/"><img src="{brandBarLogoMerid}" alt="meridien"></a></li>
                        <li><a target="_blank" href="http://renaissance-hotels.marriott.com/"><img src="{brandBarLogoRen}" alt="Renaissance Hotels"></a></li>
                        <br>
                        <li><a target="_blank" href="http://www.autograph-hotels.marriott.com/"><img src="{brandBarLogoAuto}" alt="Autograph Hotels"></a></li>
                        <li><a target="_blank" href="https://tribute-portfolio.marriott.com/"><img src="{brandBarLogoTrib}" alt="tribute portfolio"></a></li>
                        <li><a target="_blank" href="https://design-hotels.marriott.com/"><img src="{brandBarLogoDesign}" alt="design hotels"></a></li>
                        <li><a target="_blank" href="https://themarriottvacationclubs.marriott.com/?loc=IM59*1-2G4AEE&cid=corp-mvc-mi-global-bonvoy-ribbon-logo"><img src="{brandBarLogoVacaClub}" alt="Marriott Vacation Club"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/gaylord-hotels/travel.mi"><img src="{brandBarLogoGL}" alt="Gaylord Hotels"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/marriott-brands/mgm-collection.mi"><img src="{brandBarLogoMGM}" alt="MGM Collection"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/brands/outdoor-collection.mi"><img src="{brandBarLogoOutdoorCollection}" alt="Outdoor Collection"></a></li>
                    </ul>
                  </div>
              </div>
              <div class="footer-brand-grp3">
                            <div class="footer-category-con">
                   <span title="{copySource.footer.footerbar.grp3}">{copySource.footer.footerbar.grp3}</span>
                </div>
                  <div class="footer-logo-list-con">
                    <ul class="footer-logo-list" id="footer-logo-list-select">
                        <li><a target="_blank" href="https://www.marriott.com/courtyard/travel.mi"><img src="{brandBarLogoCourt}" alt="courtyard"></a></li>
                        <li><a target="_blank" href="https://four-points.marriott.com/"><img src="{brandBarLogoFP}" alt="four points"></a></li>
                        <li><a target="_blank" href="http://springhillsuites.marriott.com/"><img src="{brandBarLogoSpring}" alt="Springhill Suites"></a></li>
                        <li><a target="_blank" href="http://fairfield.marriott.com/"><img src="{brandBarLogoFair}" alt="Fair Field"></a></li>
                        <li><a target="_blank" href="http://achotels.marriott.com/"><img src="{brandBarLogoAC}" alt="AC Hotels"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/brands/citizenm.mi"><img src="{brandBarLogoCitizenM}" alt="CitizenM" style="max-width: 52px; heigh: auto; margin: auto;"></a></li>
                        <li><a target="_blank" href="https://aloft-hotels.marriott.com/"><img src="{brandBarLogoLoft}" alt="aloft"></a></li>
                        <li><a target="_blank" href="http://moxy-hotels.marriott.com/"><img src="{brandBarLogoMoxy}" alt="moxy hotels"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/protea-hotels/travel.mi"><img src="{brandBarLogoProt}" alt="protea hotels"></a></li>
                    </ul>
                </div>
            </div>
            <div class="footer-brand-grp4">
                <div class="footer-category-con">
                    <span title="{copySource.footer.footerbar.grp4}">{copySource.footer.footerbar.grp4}</span>
                </div>
                <div class="footer-logo-list-con">
                    <ul class="footer-logo-list" id="footer-logo-list-midscale">
                        <li><a target="_blank" href="https://www.marriott.com/marriott-brands/city-express.mi"><img src="{brandBarLogoCityExpress}" alt="city express"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/marriott-brands/four-points-flex.mi"><img src="{brandBarLogoFourPointsExpress}" alt="four points flex"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/brands/series-by-marriott.mi"><img src="{brandBarLogoSeriesByMarriott}" alt="Series By Marriott"></a></li>
                     </ul>  
                </div>
              </div>
              <div class="footer-brand-grp5">
                <div class="footer-category-con">
                   <span title="{copySource.footer.footerbar.grp5}">{copySource.footer.footerbar.grp5}</span>
                </div>
                <div class="footer-logo-list-con">
                    <ul class="footer-logo-list" id="footer-logo-list-longstay">
                        <li><a target="_blank" href="http://www.residenceinn.marriott.com/"><img src="{brandBarLogoRes}" alt="Residence Inn"></a></li>
                        <li><a target="_blank" href="http://towneplacesuites.marriott.com/"><img src="{brandBarLogoTown}" alt="Towne place suites"></a></li>
                        <li><a target="_blank" href="https://element-hotels.marriott.com/"><img src="{brandBarLogoEle}" alt="element"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/brands/studiores.mi"><img src="{brandBarLogoStudiorRes}" alt="StudioRes"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/marriott-brands/apartments-by-marriott-bonvoy.mi"><img src="{brandBarLogoApartments}" alt="apartments"></a></li>
                        <li><a target="_blank" href="https://homes-and-villas.marriott.com/"><img src="{brandBarLogoHomes}" alt="Homes and Villas"></a></li>
                        <li><a target="_blank" href="https://www.marriott.com/executive-apartments/travel.mi"><img src="{brandBarLogoMarriott}" alt="Executive Apartments"></a></li>
                     </ul>  
                </div>
              </div>
           </div>
        </div>
       </div>
       <!-- Rebrand -->

    <div class="footer-contents">
        <div class="footer-line-one">
            <p> 
                {copySource.footer.copyrightOne}
                <a rel="noopener noreferrer" target="_blank" href="{copySource.footer.copyrightLinkOne}">{copySource.footer.copyrightTwo}</a>
                {copySource.footer.copyrightThree}
                <a rel="noopener noreferrer" target="_blank" href="{copySource.footer.copyrightLinkTwo}">{copySource.footer.copyrightFour}</a>
                {copySource.footer.copyrightFive}
                <a rel="noopener noreferrer" target="_blank" href="{copySource.footer.copyrightLinkThree}">{copySource.footer.copyrightSix}</a>
                {copySource.footer.copyrightSeven}
            </p>
            <div>
                <img class="lang-icon" src={copySource.footer.langIconSrc} alt={copySource.footer.langIconAlt}>
                <!-- svelte-ignore a11y-no-onchange -->
                <select bind:value={copySource.lang} on:change={switchHandler}>
                    <option value="de-de">{copySource.footer.options.de}</option>
                    <option value="es-es">{copySource.footer.options.es}</option>
                    <option value="en-us">{copySource.footer.options.en}</option>
                    <option value="fr-fr">{copySource.footer.options.fr}</option>
                    <option value="it-it">{copySource.footer.options.it}</option>
                    <option value="ja-jp">{copySource.footer.options.jp}</option>
                    <option value="pt-br">{copySource.footer.options.pt}</option>
                    <option value="zh-cn">{copySource.footer.options.ch}</option>
                </select>
            </div>
            
        </div>
        <div class="footer-line-two">
            <ul>
                <li id="footer-tracking-link"><a href="{copySource.footer.tracking.prefs.href}">{copySource.footer.tracking.prefs.copy}</a></li>
                <li><a href="{copySource.footer.terms.href}">{copySource.footer.terms.copy}</a></li>
                <li><a href="{copySource.footer.programTerms.href}">{copySource.footer.programTerms.copy}</a></li>
                <li><a href="{copySource.footer.privacy.href}">{copySource.footer.privacy.copy}</a></li>
                <li><a href="{copySource.footer.tracking.doNotSell.href}">{copySource.footer.tracking.doNotSell.copy}</a></li>
                <li><a href="{copySource.footer.accessibility.href}">{copySource.footer.accessibility.copy}</a></li>
                <li><a href="{copySource.footer.siteMap.href}">{copySource.footer.siteMap.copy}</a></li>
                <li><a href="{copySource.footer.help.href}">{copySource.footer.help.copy}</a></li>
            </ul>
        </div>
        
    </div>
    
</footer>